module.exports = __webpack_public_path__ + "img/ValuePropotition.c9d9b903.png";